import { EMAIL_SUBSCRIPTION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useEmailSubscriptionFilter } from '../../hooks/useEmailSubscriptionFilter';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import ConditionError from '../common/ConditionError';
import EditorConditionInputs from './EditorConditionInputs';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorEmailSubscriptionRelatedConditionsGroup = props => {
  const {
    condition,
    conditionPath,
    dataSeleniumInfo
  } = props;
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EMAIL_SUBSCRIPTION, conditionPath, condition);
  const {
    statusCondition
  } = useEmailSubscriptionFilter(condition);
  const heading = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
      condition: statusCondition,
      dataSeleniumInfo: dataSeleniumInfo,
      filterFamily: EMAIL_SUBSCRIPTION,
      onConditionOperatorChange: onFieldConditionOperatorChange,
      onConditionValueChange: onFieldConditionValueChange
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
  return /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    dataSeleniumInfo: dataSeleniumInfo,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  });
};
export default EditorEmailSubscriptionRelatedConditionsGroup;